import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const addCommentStmtInstruction = `
#### Add Comment
Add a comment to a view or scope. This is useful for adding notes or descriptions to your views and scopes.

- Syntax: \`add comment "<comment>" in <view_name>.<scope_name>;\`
- Example: \`add comment "This data-grid scope should show only available products" in ProductList;\`
- Example: \`add comment "This data-grid scope should show only available products" in ProductList.ProductScope;\`
`;
export const stmtAddStructureComment = ({ comment, viewName, scopeName }) => {
    return `add comment "${comment}" in ${viewName}.${scopeName};`;
};
export const addCommentHandler = createStructureStatementHandler({
    type: 'add comment',
    parse: line => {
        const match = /^(add|create) comment "(?<comment>.+)" in (?<viewName>\w+)(.(?<scopeName>\w+))?/.exec(line);
        return match?.groups
            ? {
                type: 'add comment',
                comment: match.groups.comment,
                viewName: match.groups.viewName,
                scopeName: match.groups.scopeName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.addComment({
                comment: stmt.comment,
                viewName: stmt.viewName,
                scopeName: stmt.scopeName,
            });
        });
    },
});
//# sourceMappingURL=AddCommentStmt.js.map